{
	"cancelOrder": {
		"title": "Отмена ордера",
		"ticker": "Тикер",
		"option": "Опцион",
		"operation": "Операция",
		"quantity": "Количество",
		"price": "Цена",
		"orderType": "Тип ордера",
		"executed": "Исполнено",
		"orderDuration": "Срок",
		"limitPrice": "Лимит цена",
		"sharePerContract": "Акции в опционе",
		"sum": "Цена",
		"no": "Нет",
		"yes": "Да",
		"side": {
			"buy": "Купить",
			"sell": "Продать",
			"sell_short": "Продажа в шорт"
		},
		"types": {
			"market": "Рыночный",
			"limit": "Лимитный",
			"stop": "Стоп",
			"stop_limit": "Стоп-лимитный",
			"trailing_stop": "Трейлинг-стоп"
		},
		"terms": {
			"day": "DAY",
			"gtc": "GTC",
			"opg": "OPG",
			"cls": "CLS",
			"ioc": "IOC",
			"dayPlus": "DAY+"
		},
		"attributes": {
			"stop_loss": "Stop Loss",
			"take_profit": "Take Profit"
		},
		"orderSuccessfullyCanceled": "Ордер успешно отменен!",
		"couldn'tCancelOrder": "Не удалось отменить ордер."
	}
}
